import React from 'react';
import { YoutubeEmbed } from '@ncl/modules/shared/components';
import BackIcon from '../../../../../../assets/images/leftArrow.svg';
import { Wrapper, BackButton } from './Resolution382Video.styles';

const Resolution382Video = ({ onBackClick, embedId }) => {
  return (
    <Wrapper data-testid="resolution-382-video-wrapper">
      <BackButton onClick={() => onBackClick()}>
        <BackIcon />
        Voltar
      </BackButton>
      <YoutubeEmbed embedId={embedId} />
    </Wrapper>
  );
};

export default Resolution382Video;
